/* ==========================================================================
   PALMONAS MOBILE MENU JAVASCRIPT
   ========================================================================== */

(function () {
  function initPalmonasMobileMenu() {
    const section = document.querySelector('#HamburgerMenu-hamburger-menu');
    const openButton = document.querySelector('#hamburger-button');
    const overlay = document.querySelector('[data-menu-overlay]');

    if (!section) return;

    // Teleport drawer and overlay to document.body so they are not trapped inside sticky-header
    if (overlay && overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }
    if (section && section.parentElement !== document.body) {
      document.body.appendChild(section);
    }

    const closeButton = section.querySelector('[data-menu-close]');
    const tabTriggers = section.querySelectorAll('[data-menu-tab-trigger]');
    const tabPanels = section.querySelectorAll('[data-menu-tab-panel]');
    const accordionToggles = section.querySelectorAll('[data-accordion-toggle]');

    function openAccordion(toggle, content, icon) {
      toggle.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      content.classList.add('is-open');
      if (icon) icon.textContent = '−';
    }

    function closeAccordion(toggle, content, icon) {
      toggle.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      content.classList.remove('is-open');
      if (icon) icon.textContent = '+';
    }

    function openMenu() {
      section.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.classList.add('hamburger-menu-open');
      if (openButton) openButton.setAttribute('aria-expanded', 'true');
    }

    function closeMenu() {
      section.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.classList.remove('hamburger-menu-open');
      if (openButton) openButton.setAttribute('aria-expanded', 'false');
    }

    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('#hamburger-button, [data-menu-trigger]');
      if (trigger) {
        e.preventDefault();
        openMenu();
      }
    });

    if (closeButton) {
      closeButton.addEventListener('click', function (e) {
        e.preventDefault();
        closeMenu();
      });
    }

    if (overlay) {
      overlay.addEventListener('click', function (e) {
        e.preventDefault();
        closeMenu();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && section.classList.contains('is-open')) {
        closeMenu();
      }
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth >= 1250 && section.classList.contains('is-open')) {
        closeMenu();
      }
    });

    tabTriggers.forEach((trigger) => {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        const tab = this.dataset.tab;

        tabTriggers.forEach((btn) => btn.classList.remove('is-active'));
        tabPanels.forEach((panel) => panel.classList.remove('is-active'));

        this.classList.add('is-active');

        const activePanel = section.querySelector('[data-menu-tab-panel][data-tab="' + tab + '"]');
        if (activePanel) activePanel.classList.add('is-active');
      });
    });

    accordionToggles.forEach((toggle) => {
      const content = toggle.nextElementSibling;
      const icon = toggle.querySelector('.hamburger-menu__icon');

      if (toggle.classList.contains('is-open') && content) {
        content.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        if (icon) icon.textContent = '−';
      } else {
        toggle.setAttribute('aria-expanded', 'false');
        if (icon) icon.textContent = '+';
      }

      let isTouchHandled = false;

      toggle.addEventListener('touchend', function (event) {
        event.preventDefault();
        isTouchHandled = true;

        const content = this.nextElementSibling;
        const icon = this.querySelector('.hamburger-menu__icon');
        if (!content) return;

        if (this.classList.contains('is-open')) {
          closeAccordion(this, content, icon);
        } else {
          openAccordion(this, content, icon);
        }
      });

      toggle.addEventListener('click', function (e) {
        if (isTouchHandled) {
          isTouchHandled = false;
          return;
        }

        const content = this.nextElementSibling;
        const icon = this.querySelector('.hamburger-menu__icon');
        if (!content) return;

        if (this.classList.contains('is-open')) {
          closeAccordion(this, content, icon);
        } else {
          openAccordion(this, content, icon);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPalmonasMobileMenu);
  } else {
    initPalmonasMobileMenu();
  }
  document.addEventListener('shopify:section:load', initPalmonasMobileMenu);
})();
